import script from "./MindMap.vue?vue&type=script&setup=true&lang=js"
export * from "./MindMap.vue?vue&type=script&setup=true&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=70daa489&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70daa489"]])

export default __exports__